import type { Locale } from "src/lib/Intl";
import {
  ShopTypeButtonsWrapper,
  SearchResultContentContainer,
} from "../SearchResults.styled";
import { useMemo } from "react";
import { locale } from "src/config/app-config";
import { ShopTypeButton } from "./ShopTypeButton";

const filterOutGender: { [key in Locale]?: string[] } = {
  "en-gb": ["kids"],
};

function ShopTypeButtons() {
  const buttons = useMemo(() => {
    const shopTypes = ["women", "men", "kids"];

    const filteredShopTypes = shopTypes.filter(
      (shopType) => !filterOutGender[locale]?.includes(shopType)
    );

    return filteredShopTypes.map((shopTypeId, idx) => (
      <ShopTypeButton
        key={`search-shoptype-${shopTypeId.toLowerCase()}-${idx}`}
        shopTypeId={shopTypeId}
      />
    ));
  }, []);

  return (
    <SearchResultContentContainer>
      <ShopTypeButtonsWrapper
        style={{ "--number-of-items": buttons.length } as React.CSSProperties}
        role="list"
        aria-label="shop types"
      >
        {buttons}
      </ShopTypeButtonsWrapper>
    </SearchResultContentContainer>
  );
}

export { ShopTypeButtons };
